import { createRouter, createWebHistory } from 'vue-router';

// Critical path routes (loaded immediately)
import Home from './pages/Home.vue';
import IpoList from './pages/IpoList.vue';
import IpoDetail from './pages/IpoDetail.vue';

// Route-based code splitting for non-critical pages
const IpoDashboard = () => import('./pages/IpoDashboard.vue');
const IpoCalendar = () => import('./pages/IpoCalendar.vue');
const IpoTimetable = () => import('./pages/IpoTimetable.vue');
const IpoPerformance = () => import('./pages/IpoPerformance.vue');
const IpoListingDates = () => import('./pages/IpoListingDates.vue');
const UpcomingIpos = () => import('./pages/UpcomingIpos.vue');
const Gmp = () => import('./pages/Gmp.vue');
const Subscriptions = () => import('./pages/Subscriptions.vue');
const Allotments = () => import('./pages/Allotments.vue');
const Ncds = () => import('./pages/Ncds.vue');
const RightsIssues = () => import('./pages/RightsIssues.vue');
const Buybacks = () => import('./pages/Buybacks.vue');
const Ofs = () => import('./pages/Ofs.vue');
const News = () => import('./pages/News.vue');
const NewsDetail = () => import('./pages/NewsDetail.vue');
const AdminGmp = () => import('./pages/AdminGmp.vue');
const AdminDashboard = () => import('./pages/AdminDashboard.vue');
const AdminLogs = () => import('./pages/AdminLogs.vue');
const AdminIpos = () => import('./pages/AdminIpos.vue');
const AdminArticles = () => import('./pages/AdminArticles.vue');
const AdminAiSuggestions = () => import('./pages/AdminAiSuggestions.vue');
const Login = () => import('./pages/Login.vue');
const Register = () => import('./pages/Register.vue');
const CompareIpo = () => import('./pages/CompareIpo.vue');
const IpoScreener = () => import('./pages/IpoScreener.vue');
const NotFound = () => import('./pages/NotFound.vue');
// Guides, policies and About/Contact are authored server-side (Blade) and
// rendered from the server's HTML — see components/ServerPage.vue.
const ServerPage = () => import('./components/ServerPage.vue');
const SearchResults = () => import('./pages/SearchResults.vue');

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, saved) {
        if (saved) return saved;
        if (to.hash) return { el: to.hash };
        return { top: 0 };
    },
    routes: [
        { path: '/', component: Home },
        { path: '/ipos', component: IpoList },
        { path: '/ipos/dashboard', component: IpoDashboard },
        { path: '/ipos/upcoming', component: UpcomingIpos },
        { path: '/ipos/calendar', component: IpoCalendar },
        { path: '/ipos/timetable', component: IpoTimetable },
        { path: '/ipos/performance', component: IpoPerformance },
        { path: '/ipos/reviews', component: ServerPage }, // no verified review data; see SiteController::reviews
        { path: '/ipos/listing-dates', component: IpoListingDates },
        { path: '/ipos/:slug', component: IpoDetail },
        { path: '/gmp', component: Gmp },
        { path: '/subscriptions', component: Subscriptions },
        { path: '/allotments', component: Allotments },
        { path: '/ncds', component: Ncds },
        { path: '/rights-issues', component: RightsIssues },
        { path: '/buybacks', component: Buybacks },
        { path: '/ofs', component: Ofs },
        { path: '/news', component: News },
        { path: '/news/:slug', component: NewsDetail },
        { path: '/learn', component: ServerPage },
        { path: '/learn/:slug', component: ServerPage },
        { path: '/compare', component: CompareIpo },
        { path: '/screener', component: IpoScreener },
        { path: '/search', component: SearchResults },
        { path: '/login', component: Login },
        { path: '/register', component: Register },
        { path: '/about', component: ServerPage },
        { path: '/contact', component: ServerPage },
        { path: '/privacy', component: ServerPage },
        { path: '/terms', component: ServerPage },
        { path: '/disclaimer', component: ServerPage },
        { path: '/methodology', component: ServerPage },
        { path: '/corrections-policy', component: ServerPage },
        { path: '/editorial-policy', component: ServerPage },
        { path: '/admin/dashboard', component: AdminDashboard, meta: { auth: true } },
        { path: '/admin/logs', component: AdminLogs, meta: { auth: true } },
        { path: '/admin/gmp', component: AdminGmp, meta: { auth: true } },
        { path: '/admin/ipos', component: AdminIpos, meta: { auth: true } },
        { path: '/admin/articles', component: AdminArticles, meta: { auth: true } },
        { path: '/admin/ai-suggestions', component: AdminAiSuggestions, meta: { auth: true } },
        { path: '/:pathMatch(.*)*', component: NotFound },
    ],
});

router.beforeEach((to) => {
    if (to.meta.auth) {
        const token = localStorage.getItem('token');
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        if (!token || !user?.is_admin) {
            return '/login';
        }
    }
});

export default router;
